import { useNavigate } from "react-router-dom";
import { useStore } from "@/state/store";
import { IconLogout } from "./SvoIcons";

interface Props {
  variant?: "light" | "dark";
}

export function LogoutButton({ variant = "light" }: Props) {
  const { dispatch } = useStore();
  const navigate = useNavigate();

  const logout = () => {
    dispatch({ type: "auth/logout" });
    try {
      window.localStorage.removeItem("offsite:auth");
    } catch {
      /* noop */
    }
    navigate("/", { replace: true });
  };

  const klass = variant === "dark" ? "btn btn-ghost-on-dark" : "btn btn-ghost";

  return (
    <button type="button" onClick={logout} className={klass}>
      <IconLogout size={16} />
      Abmelden
    </button>
  );
}
